import moment from 'moment';
import {PaxNode} from 'common/types/carriable';

export function toManifestPrintoutTime(estDepartureTime?: string | null) {
    if (!estDepartureTime) {
        return undefined;
    }

    const time = moment(estDepartureTime, 'HH:mm');

    return {
        hour: time.hours(),
        minute: time.minutes()
    };
}

/** Retains passenger history even when its optional master person reference no longer resolves. */
export function toManifestPassenger(pax: PaxNode) {
    return {
        _id: pax._id,
        lastName: pax.lastName,
        firstName: pax.firstName,
        employer: pax.employerID?.name,
        chargeCode: pax.chargeCode?.toUpperCase(),
        paxWeight: pax.paxWeight,
        bagWeight: pax.bagWeight,
        departure: pax.departureID?.name,
        destination: pax.destinationID?.name,
        dob: pax.personID?.dob,
        nation: pax.personID?.nation,
        credentials: pax.personID?.credentials || []
    };
}
